import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ExpedienteService {
    /*VARIABLE PARA OBTENER INFORMACIÓN*/ 
    idEmpresa: string;
    idUsuario: string;
    infoUsuario: any;
    idInstituto: string;
  
    private mensajeOrigen = new BehaviorSubject('');
    mensajeActual = this.mensajeOrigen.asObservable();
  
    constructor(
      private http:HttpClient,
      private authService:AuthService
    ) {
      this.obtienInfo();
    }
  
    obtienInfo()
    {
      this.idUsuario = this.authService.getIdUsuario();
      this.idInstituto = this.authService.getInstituto();
      let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
      this.idEmpresa = infoUsu.empresaId;
      this.infoUsuario = this.authService.getInfoUsuario();
    }
  
    getInfoUsuario(){
      return this.infoUsuario;
    }
  
    puenteDatos(mensaje: string) {
      this.mensajeOrigen.next(mensaje);
    }
  
    getProdCertAct(){
      this.obtienInfo();
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
    }
  
    getProductoGestor(){
      this.obtienInfo();
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.productoGestor + this.idEmpresa,null);
    }
  
    guardaArchivo(datos:any){
      this.obtienInfo();
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.cargaArchivo + this.idEmpresa, datos);
    }
  
    getArchivos(folder:string){
      this.obtienInfo();
      let datos = {nombreCarpeta: folder};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getArchivos + this.idEmpresa, datos);
    }
  
    getArchivosInstituto(instituto:number){
      this.obtienInfo();
      let datos = {instituto:instituto};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getArchivosInstituto,datos);
    }
  
    eliminaArchivo(datos:any){
      this.obtienInfo();
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.borraArchivo + this.idEmpresa,datos);
    }

    // PARTE PARA CARGAR CENTROS DE TRABAJO
    getInfoCentros(fecha:number){
      this.obtienInfo();
      let datos = {fechaNorma35:fecha};
      if(localStorage.getItem('Leveuser') == '6'){
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + localStorage.getItem('idPadre_temporal'), datos);
      }else{
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + this.idEmpresa, datos);
      }

      
    }

    getInfoColaboradores(anio: number, producto: string){
      this.obtienInfo();
      if(localStorage.getItem('Leveuser') == '6'){
        let datos: any = {fechaNorma35: anio, productoId:localStorage.getItem('idProducto_padre'), token:'$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO'};
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getColaboradores + this.idEmpresa, datos);
      }else{
        let datos: any = {fechaNorma35: anio, productoId:producto, token:'$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO'};
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getColaboradores + this.idEmpresa, datos);
      }

      
    }
   
    // FUNCIONEA TALE COLABORADORES
    saveTableBolacoradores(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.savetableColaboradores + this.idEmpresa, data);
    }
    saveTableBolacoradores2(data:any,idEmpresa){ // Misma función que la anterior, solo que para centros de trabajos hijos
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.savetableColaboradores + idEmpresa, data);
    }

    getTableBolacoradores(productoId, idColaborador){
      if(localStorage.getItem('Leveuser') == '6'){
        let datos: any = { productoId:localStorage.getItem('idProducto_padre'), colaboradorId:idColaborador};
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.movetableColaboradores + localStorage.getItem('idPadre_temporal'), datos);
      }else{
        let datos: any = { productoId:productoId, colaboradorId:idColaborador};
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.movetableColaboradores + this.idEmpresa, datos);
      }
      //return this.http.post(DATOS_API.url + DATOS_API.endpoints.movetableColaboradores + this.idEmpresa, data);
    }

    getTableBolacoradoresCT(data:any, idEmpresa:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.movetableColaboradores + idEmpresa, data);
    }
    borrarArchivo(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.deleteFileExp + this.idEmpresa, data);
    }

    borrarArchivo_CT(data:any,idEmpresa:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.deleteFileExp + idEmpresa, data);
    }

    pruebacolaboradores(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getColaboradores + this.idEmpresa, data);
    }

    getAyudaColaboradores(data:any){
      if(localStorage.getItem('Leveuser') == '6'){
        let datos: any = {productoId: localStorage.getItem('idProducto_padre')}
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getPersonasAyuda + localStorage.getItem('idPadre_temporal'), datos);
      }else{
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getPersonasAyuda + this.idEmpresa, data);return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getPersonasAyuda + this.idEmpresa, data);
      }
    }

    geAlltAyudaColaboradores(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getAllPersonasAyuda + this.idEmpresa, data);
    }

    guardarDoctores(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.savedoctors, data);
    }

    getDoctores(productoId){
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.expedientes.getMedicos + this.idEmpresa + '/' + productoId);
    }

    deleteDoctores(idDoctor){
      return this.http.delete(DATOS_API.url + DATOS_API.endpoints.expedientes.deleteMedicos + idDoctor);
    }

    saveClave(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.savekey, data);
    }

    getClave(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getkey, data);
    }

    getAllclave(data:any){
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getAllkey, data);
    }

    getAlldoctordates(idDoctor){
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.doctores.getAlldoctordates + idDoctor);
    }
  
  }
  